import React, { useState, FC, useMemo, useContext } from "react";
import { Helmet } from "react-helmet-async";

const TitleContext = React.createContext<{ title: string; setTitle(title: string): void }>({
  title: "",
  setTitle: () => {}
});

export const TitleProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState("");

  const providerValue = useMemo(() => {
    return { title, setTitle };
  }, [title]);

  return (
    <TitleContext.Provider value={providerValue}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </TitleContext.Provider>
  );
};

export function useHeaderTitle() {
  return useContext(TitleContext);
}
